import type { ReactNode } from "react";
import { Icon, type IconName } from "./Icon";
import type { Tone } from "./tone";
import "./status-pill.css";

type StatusIcon = Extract<IconName, "check" | "clock" | "minus" | "lock" | "alert">;

type Props = { tone: Tone; icon: StatusIcon; children: ReactNode };

// Lo stato di una riga: testo e icona insieme, mai il solo colore (UX_SYSTEM: l'accessibilità non
// dipende dal colore). `icon` è obbligatoria per questo: non si può dimenticare.
export function StatusPill({ tone, icon, children }: Props) {
  return (
    <span className="g-pill" data-tone={tone}>
      <Icon name={icon} />
      {children}
    </span>
  );
}
